var React = require('react');

function MailIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.625 0.625)"},[React.createElement("rect",{"width":"15.468","height":"11.936","rx":"2","transform":"translate(0 0)","fill":"none","stroke":"#c7a374","strokeMiterlimit":"10","strokeWidth":"1.25","key":0}),React.createElement("path",{"d":"M12.547,80.082l4.645,4.41a.767.767,0,0,0,1.056,0l4.645-4.41","transform":"translate(-9.976 -77.289)","fill":"none","stroke":"#c7a374","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"1.25","key":1})]));
}

MailIcon.defaultProps = {"width":"16.718","height":"13.186","viewBox":"0 0 16.718 13.186"};

module.exports = MailIcon;

MailIcon.default = MailIcon;
